// Translation file for IdegenNyelviKorulmenyek component
// Contains all UI text in Hungarian and English

export const IDEGENNYELVIKORULMENYEK_TRANSLATIONS = {
    hu: {
        pageTitle: "4. Idegen nyelvi követelmények",
        
        section1: {
            title: "4.1. Hallgatói mobilitás",
            source: "Forrás: ",
            subtitle1: "Mobilitásban résztvevő hallgatók arányának értékelése",
            subtitle2: "A mobilitás alakulása az előző évekhez képest",
            subtitle3: "Bejövő (incoming) nemzetközi hallgatók",
            subtitle4: "Mobilitás hozzájárulása a szakhoz",
            description2: "Kérjük jelölje meg, hogy a hallgatói mobilitás milyen módon járult hozzá a szak céljaihoz (több válasz is jelölhető):"
        },
        
        section2: {
            title: "4.2. Mobilitási ablak",
            description1: "Kérjük, mutassa be, hogy a mintatantervben hogyan valósul meg a mobilitási ablak. A mobilitási ablak a képzés tantervébe beépített, nemzetközi hallgatói mobilitásra fenntartott időszak. Célja, hogy megkönnyítse a hallgatók nemzetközi mobilitásban való részvételét.",
            description2: "Jelölje meg azokat a féléveket, amelyben javasolja a hallgatók részére a nemzetközi mobilitást, rövid szakmai tanulmányi utat, mikrotanúsítvánnyal záruló rövid képzési programot.",
            noteLabel: "Megjegyzés (opcionális):",
            subtitle: "Kérjük mutassa be a mobilitás során teljesített kreditek elismerésének módszerét"
        },
        
        section3: {
            title: "4.3. Idegen szaknyelvi képzés",
            source: "Forrás: ",
            description1: "Mintatantervben lévő, idegen nyelvi képzést biztosító tantárgyak",
            description2: "(Csak magyar nyelvű képzések esetén)",
            subtitle1: "A mintatantervben szereplő általános (nem szaknyelvi) nyelvi kurzusok",
            subtitle2: "A mintatantervben dedikáltan szaknyelvi képzést biztosító tantárgyak",
            subtitle3: "A szak kínál-e teljes egészében idegen nyelven oktatott kurzusokat"
        },
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden szöveges mezőt ki kell tölteni!"
        },
        
        modal: {
            imageAlt: "Nagyított kép",
            closeButton: "Bezárás"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    
    en: {
        pageTitle: "4. Foreign Language Requirements",
        
        section1: {
            title: "4.1. Student Mobility",
            source: "Source: ",
            subtitle1: "Assessment of the proportion of students participating in mobility programmes",
            subtitle2: "Trends in mobility compared to previous years",
            subtitle3: "Incoming international students",
            subtitle4: "Contribution of mobility to the programme",
            description2: "Please indicate in what ways student mobility has contributed to the objectives of the programme (multiple answers may be selected):"
        },
        
        section2: {
            title: "4.2. Mobility Window",
            description1: "Please describe how the mobility window is implemented in the sample curriculum. The mobility window is a designated period embedded in the curriculum and reserved for international student mobility. Its purpose is to facilitate students’ participation in international mobility, short-term professional study visits, or short training programmes concluding with a micro-credential.",
            description2: "Please indicate the semesters during which international mobility, short-term professional study visits, or short training programmes leading to a micro-credential are recommended for students.",
            noteLabel: "Comments (optional):",
            subtitle: "Please describe the methods used for the recognition of credits completed during mobility"
        },
        
        section3: {
            title: "4.3. Foreign Language for Specific Purposes (LSP) Education",
            description1: "Courses providing foreign language education included in the sample curriculum",
            source: "Source: ",
            description2: " (For Hungarian-taught programmes only)",
            subtitle1: "General (non-specialised) language courses included in the sample curriculum",
            subtitle2: "Courses specifically providing language education for specific purposes included in the sample curriculum",
            subtitle3: "Does the programme offer courses taught entirely in a foreign language"
        },
        
        buttons: {
            previous: "Previous Section",
            next: "Next Section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Withdraw Finalization"
        },
        
        alerts: {
            requiredFields: "All text fields must be filled!"
        },
        
        modal: {
            imageAlt: "Enlarged image",
            closeButton: "Close"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};